import React, { useEffect, useState } from 'react';
import './Testimonials.css';

const testimonials = [
  { name: 'AkshayaChannai', image: '/Media/Testimonials/1.jpg', comment: 'The instructors here make yoga accessible and joyful, even for beginners.' },
  { name: 'AnuragBansal', image: '/Media/Testimonials/2.jpg', comment: 'The blend of traditional yoga with modern understanding is truly unique. Highly recommended.' },
  { name: 'BrandonMcmahanUS', image: '/Media/Testimonials/3.jpg', comment: 'A beautiful space with expert teachers who really care about each student’s progress.' },
  { name: 'DoraHungry', image: '/Media/Testimonials/4.jpg', comment: 'Clean environment and disciplined classes. Perfect for yoga lovers.' },
  { name: 'EstellaIT', image: '/Media/Testimonials/5.jpg', comment: 'The atmosphere is so positive and uplifting, it’s impossible to leave without a smile.' },
  { name: 'LeahGermnay', image: '/Media/Testimonials/6.jpg', comment: 'This place is more than a yoga studio — it’s a community that inspires you to grow.' },
  { name: 'ManojShrivastav', image: '/Media/Testimonials/7.jpg', comment: 'They focus on both body and mind, creating a complete wellness experience.' },
];

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Auto-scroll every 10 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex(prevIndex => (prevIndex + 1) % testimonials.length);
    }, 10000);
    return () => clearInterval(interval);
  }, []);

  const handleDotClick = (index) => {
    setCurrentIndex(index);
  };

  return (
    <section className="testimonials" id="testimonials">
      <h2>What Our Students Say</h2>
      <div className="testimonial-container">
        <div className="testimonial-card">
          <img
            src={testimonials[currentIndex].image}
            alt={testimonials[currentIndex].name}
            className="testimonial-image"
          />
          <div className="testimonial-text">
            <h4>{testimonials[currentIndex].name}</h4>
            <p>"{testimonials[currentIndex].comment}"</p>
          </div>
        </div>
        <div className="testimonial-dots">
          {testimonials.map((_, index) => (
            <span
              key={index}
              className={`dot ${index === currentIndex ? 'active' : ''}`}
              onClick={() => handleDotClick(index)}
            ></span>
          ))}
        </div>
      </div>

      {/* Google Review Box */}
      <a
        href="https://www.google.com/search?sca_esv=58b10d05d2cc165c&rlz=1C5CHFA_enIN979IN979&sxsrf=AE3TifPzdlhBVjcKy-Q6Hov5uLIDuzdtig:1754805305976&si=AMgyJEtREmoPL4P1I5IDCfuA8gybfVI2d5Uj7QMwYCZHKDZ-EyXQRyrnxLzXC1xj4b3V3LuXw9q_u2NtHnpBv26aJY5COgxn8yx4QgH2cQ2aWSi_y2Wg63sQUB9KftAc6fUgkN1NQ62Dh59Mq47asrpKUy0-OsK3_w%3D%3D&q=Yog+Yatra+Institute+Reviews&sa=X&ved=2ahUKEwjKn6aXx_-OAxWNxjgGHS70F9MQ0bkNegQIIhAE&biw=1440&bih=718&dpr=2"
        target="_blank"
        rel="noopener noreferrer"
        className="google-review-box"
      >
        <span className="stars">
          ★ ★ ★ ★ ★
        </span>
        <span className="review-text">Please Click Here to rate us on Google</span>
      </a>
    </section>
  );
};

export default Testimonials;
